<template>
  <div class="actionBlock">
    <v-menu offset-y :min-width="250">
      <template v-slot:activator="{ on }">
        <v-btn text color="secondary" v-on="on" title="Guide for Register Claim" id="guideRegisterClaimBtn" v-if="isMatchRouteExact('claimRegister')">
          Guide
          <v-icon right>mdi-television-guide</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="startTour()">
          <v-list-item-avatar>
            <v-icon>mdi-presentation-play</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Quick Tour</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <v-menu offset-y :min-width="250">
      <v-btn text color="secondary" v-on="on" title="Guide for Claim Header" id="guideClaimHeaderBtn" v-if="isMatchRouteExact('claimHeader')">
        Guide
        <v-icon right>mdi-television-guide</v-icon>
      </v-btn>
      <v-list>
        <v-list-item avatar @click="startTour()">
          <v-list-item-avatar>
            <v-icon>mdi-presentation-play</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Quick Tour</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->
    <tour ref="tour" :tour="tour"></tour>
  </div>
</template>

<script>
import routeMixin from '@/mixins/route'
import ClaimRegisterTour from '@/const/tour/claimManagement/register'
export default {
  data() {
    return {
      tour: undefined
    }
  },
  methods: {
    startTour() {
      if (this.$refs.tour) {
        this.$refs.tour.startTour()
      }
    },
    doInit() {
      if (this.isMatchRouteExact('claimRegister')) {
        this.tour = ClaimRegisterTour
      } else if (this.isMatchRouteExact('claimHeader')) {
        this.tour = ClaimRegisterTour
      } else if (this.isMatchRouteExact('claimClaimant')) {
        this.tour = undefined
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin]
}
</script>

<style>
</style>
